import * as types from "../../constants/ComponentConstants";

const documentHelperUtil =
{
    getDocumentComponentProps: (title, componentName, downloadUrl, documents, isDownloadOnly, onDrop, onDelete, fileTypes, center, warning, error, color, size) => {
        const lowerComponentName = componentName.toLowerCase();
        return {
            title: title,
            componentName: lowerComponentName,
            color: color ? color : types.COLOR_BLUE,
            fileTypes: isDownloadOnly || !fileTypes ? null : fileTypes,
            downloadFileUrl: downloadUrl,
            files: documentHelperUtil.getFiles(documents, lowerComponentName),
            onDrop: isDownloadOnly ? null : onDrop(lowerComponentName),
            onDelete: isDownloadOnly ? null : onDelete(lowerComponentName),
            isDownloadOnly: isDownloadOnly,
            center: center === undefined || !center ? false : center,
            warning: warning === undefined ? null : warning,
            error: error === undefined ? null : error,
            size: size === undefined ? null : size,
            pollingEnabled: false
        };
    },
    getPollingProps: (times, minFiles, isPolling, componentName) => {
        const lowerComponentName = componentName.toLowerCase();
        return {
            pollingEnabled: true,
            minFiles: minFiles,
            pollTimes: times,
            isLoading: isPolling,
            componentName: lowerComponentName
        };
    },
    getFiles: (documents, componentName, year) => {
        const lowerComponentName = componentName.toLowerCase();
        let files = documents[lowerComponentName] ? documents[lowerComponentName] : [];
        if (year) {
            files = documents[lowerComponentName + year] ? documents[lowerComponentName + year] : [];
        }
        return files;
    },
    formatDocumentsForSave: (documents, baseUrl) => {
        let formattedFoldersWithDocuments = Object.keys(documents).map(k => {
            return ({
                files: documents[k].map(fn => {
                    return {
                        name: fn,
                        path: baseUrl + "/" + k
                    };
                }),
                name: k,
                path: baseUrl
            });
        });

        return formattedFoldersWithDocuments;
    }
};

export default documentHelperUtil;